module.exports = __webpack_public_path__ + "img/sale.30239dc6.svg";